import { createApi } from "@reduxjs/toolkit/query/react";

import { apiurl } from "@/Config/ApiConfig/ApiUrl";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";
import { mapImporterFormResponse } from "@/redux/mappers/Import/CreateNewJob/GeneralPageMaper.js";

export const importerApi = createApi({
  reducerPath: "importerApi",
  baseQuery,
  tagTypes: ["Importer"],
  endpoints: (builder) => ({
    getImportGeneralById: builder.query({
      query: ({ id }) => `/import/general/${id}`,
      transformResponse: (response) => {
        const mapped = response?.data ? mapImporterFormResponse(response.data) : null;
        return mapped;
      },
      providesTags: (result, error, id) => [{ type: "Importgeneral", id }],
    }),
    createImporter: builder.mutation({
      query: (data) => ({
        url: "/import/general",
        method: "POST",
        headers: {
          "X-Request-Id": Math.random().toString(36).substring(2),
        },
        body: data,
      }),
      invalidatesTags: ["Importer"],
    }),

    updateImporter: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/import/general/${id}`, // append id in URL
        method: "PUT",
        headers: {
          "X-Request-Id": Math.random().toString(36).substring(2),
        },
        body: data,
      }),
      invalidatesTags: ["Importer"],
    }),
  }),
});

export const { useLazyGetImportGeneralByIdQuery, useCreateImporterMutation,useUpdateImporterMutation } = importerApi;

